import { Box, Container, Grid } from '@mui/material';
import { useParams } from 'react-router-dom';

import { useGetProductQuery } from '@/apis/extended/productApi';
import { Loader } from '@/components/Layout/Loader';
import { ProductDetailBasic } from '@/components/ProductDetail/ProductDetailBasic';
import { ProductDetailEstimation } from '@/components/ProductDetail/ProductDetailEstimation';
import { ProductDetailExploreOfferButton } from '@/components/ProductDetail/ProductDetailExploreOfferButton';
import { ProductDetailLogos } from '@/components/ProductDetail/ProductDetailLogos';
import { ProductDetailProgress } from '@/components/ProductDetail/ProductDetailProgress';
import { ProductDetailProjectedPayment } from '@/components/ProductDetail/ProductDetailProjectedPayment';
import { ProductDetailPropertySpecifics } from '@/components/ProductDetail/ProductDetailPropertySpecifics';
import { AgentProductBasicDetails } from './AgentProductBasicDetails';

export const AgentProductDetailPage = () => {
  const { productId } = useParams();
  const { data: product, isLoading } = useGetProductQuery(productId!);
  if (isLoading || !product) return <Loader isFull />;

  return (
    <Container sx={{ py: '40px' }}>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <ProductDetailLogos product={product} />
        </Grid>
        <Grid item xs={12} md={6}>
          <AgentProductBasicDetails product={product} />
          <ProductDetailProgress product={product} />
        </Grid>
      </Grid>
      <Grid container spacing={4} mt={2}>
        <Grid item xs={12} md={6}>
          <ProductDetailPropertySpecifics product={product} />
          <Box
            sx={{
              position: { md: 'sticky' },
              top: '90px',
              mt: 2,
            }}
          >
            <ProductDetailProjectedPayment product={product} />
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <ProductDetailEstimation product={product} />
        </Grid>
      </Grid>
    </Container>
  );
};
